import React, { Component } from 'react';

class GeckoCardBody extends Component {
    render() {
        return (
            <div className="p-6">
                {this.props.children}
            </div>
        );
    }
}

export default GeckoCardBody;